import { useRequest } from '@umijs/max';
import { BellOutlined } from '@ant-design/icons';
import { Badge, Dropdown, theme } from 'antd';
import { getNotices } from '@/services/ant-design-pro/api';
import { createStyles } from 'antd-style';

const useStyles = createStyles(({ token }) => ({
  noticeButton: {
    display: 'inline-block',
    cursor: 'pointer',
    padding: '4px 12px',
    transition: 'all 0.3s',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.025)',
    },
  },
  popover: {
    position: 'relative',
    width: '336px',
  },
}));

export type GlobalHeaderRightProps = {
  fetchingNotices?: boolean;
  onNoticeVisibleChange?: (visible: boolean) => void;
  onNoticeClear?: (tabName: string) => void;
};

const NoticeIcon: React.FC<GlobalHeaderRightProps> = () => {
  const { styles } = useStyles();
  const { data: notices = [], loading } = useRequest(getNotices);

  const notificationCount = notices.length;

  const noticeItems = [
    {
      key: 'notification',
      label: '通知',
      children: notices.map((item: any) => ({
        key: item.id,
        label: item.title,
        onClick: () => console.log('clicked notification', item),
      })),
    },
    {
      key: 'message',
      label: '消息',
      children: [],
    },
    {
      key: 'todo',
      label: '待办',
      children: [],
    },
  ];

  return (
    <Dropdown
      menu={{
        items: noticeItems,
      }}
      placement="bottomRight"
      arrow
      trigger={['click']}
    >
      <span className={styles.noticeButton}>
        <Badge count={notificationCount} style={{ boxShadow: 'none' }} dot={false}>
          <BellOutlined style={{ fontSize: '16px' }} />
        </Badge>
      </span>
    </Dropdown>
  );
};

export default NoticeIcon;
